import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useQuestionsListStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 1440,
      margin: '120px auto 100px auto',
      [theme.breakpoints.down(1440)]: {
        margin: '120px auto 80px auto',
        padding: '0 80px',
        width: '100%'
      },
      [theme.breakpoints.down(960)]: {
        margin: '120px auto 60px auto',
        padding: '0 16px'
      }
    },

    btnBack: {
      position: 'absolute',
      left: 0,
      top: 50,
      padding: 0,
      textTransform: 'none',
      color: '#666666',
      fontSize: 14,
      '&:hover': {
        color: '#2E68BD',
        backgroundColor: 'transparent'
      },
      '&:active': {
        color: '#2E86BD',
        backgroundColor: 'transparent'
      },
      [theme.breakpoints.down(1440)]: {
        marginLeft: 80
      },
      [theme.breakpoints.down(960)]: {
        marginLeft: 16
      }
    },

    title: {
      marginBottom: '20px',
      fontSize: 36,
      fontWeight: 600,
      color: '#212121',
      fontFamily: 'Montserrat',
      [theme.breakpoints.down(1440)]: {
        fontSize: 30
      },
      [theme.breakpoints.down(960)]: {
        fontSize: 22
      },
      [theme.breakpoints.down(768)]: {
        marginTop: 40,
        fontSize: 20
      }
    },

    tab: {
      '&.MuiTab-root': {
        padding: 0,
        margin: '0 22px',
        fontFamily: 'Montserrat',
        fontSize: 16,
        fontWeight: 600,
        [theme.breakpoints.up(300)]: {
          minWidth: 'fit-content'
        },
        [theme.breakpoints.down(768)]: {
          fontSize: 12,
          margin: '0 10px'
        }
      }
    },

    divider: {
      width: '98vw'
    },

    skeleton: {
      width: '100%',
      height: 30,
      '&:not(:last-child)': {
        marginBottom: 25
      }
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'flex-start',
      width: '100%',
      [theme.breakpoints.down(768)]: {
        marginTop: 0
      }
    },

    count: {
      alignSelf: 'flex-start',
      margin: '100px 0 20px 0',
      fontSize: 14,
      color: '#757575',
      fontFamily: 'Montserrat',
      [theme.breakpoints.down(1440)]: {
        margin: '45px 0 20px 0'
      },
      [theme.breakpoints.down(768)]: {
        margin: '30px 0 20px 0',
        fontSize: 12
      }
    },

    question: {
      display: 'flex',
      flexDirection: 'column',
      '&:not(:last-child)': {
        marginBottom: 25
      },
      '&:first-child': {
        marginLeft: 5
      }
    },

    questionTitleBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': {
        color: '#2E86BD'
      }
    },

    questionNumber: {
      fontSize: 20,
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Montserrat',
      [theme.breakpoints.down(768)]: {
        fontSize: 14
      }
    },

    questionTitle: {
      marginLeft: 15,
      fontSize: 20,
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Montserrat',
      [theme.breakpoints.down(768)]: {
        fontSize: 14
      }
    },

    description: {
      maxWidth: '100%',
      padding: '16px 0',
      fontSize: 18,
      color: '#000',
      fontFamily: 'Montserrat',
      '& img': {
        maxWidth: '100%',
        height: '100%',
        objectFit: 'contain'
      },
      '& oembed': {
        width: '100%',
        height: '100%'
      },
      '& table,  td, th': {
        border: '1px solid #000',
        borderCollapse: 'collapse'
      },
      [theme.breakpoints.down(768)]: {
        fontSize: 12
      }
    },

    likes: {
      display: 'flex',
      alignItems: 'center'
    },

    likesTitle: {
      marginRight: 25,
      fontSize: 18,
      fontWeight: 500,
      color: '#2E86BD',
      fontFamily: 'Montserrat',
      [theme.breakpoints.down(768)]: {
        fontSize: 12,
        marginRight: 20
      }
    },

    likesBtn: {
      marginRight: 25,
      padding: 0,
      fontSize: 18,
      fontWeight: 500,
      color: '#2E86BD',
      fontFamily: 'Montserrat',
      textTransform: 'capitalize',
      '&:hover': {
        background: 'none'
      },
      [theme.breakpoints.down(768)]: {
        fontSize: 12,
        marginRight: 0
      }
    },

    support: {
      marginTop: 25,
      marginBottom: 80,
      alignSelf: 'flex-start',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': {
        textDecoration: 'underline'
      },
      [theme.breakpoints.down(768)]: {
        fontSize: 12
      }
    },

    pagination: {
      display: 'flex',
      marginTop: 50
    }
  })
)
